import sinAgua from "../../../../assets/sinAgua.png";
import sinColorantes from "../../../../assets/sinColorantes.png";
import sinConservantes from "../../../../assets/sinConservantes.png";
import sinEndulzantes from "../../../../assets/SinEndulzantes.png";

const dataHome1 = [
  {
    id: 1,
    img: sinAgua,
    title: "SIN AGUA",
  },
  {
    id: 2,
    img: sinColorantes,
    title: "SIN COLORANTES",
  },
  {
    id: 3,
    img: sinConservantes,
    title: "SIN CONSERVANTES",
  },
  {
    id: 4,
    img: sinEndulzantes,
    title: "SIN ENDULZANTES",
  },
];

export default dataHome1;
